import React, { VFC } from 'react';
import { Box, Loader } from '@wix/design-system';

export const LoadingState: VFC<{ dataHook: string }> = ({ dataHook }) => (
  <Box dataHook={dataHook}>
    <Loader size="large" />
  </Box>
);
